import axios from "axios";

const API = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? `${window.location.origin}/api`
      : "https://itrjainbandhutrust.com/api",

  withCredentials: true,
  timeout: 30000, // 30 seconds timeout to prevent hanging requests during large data loads
});

// Request interceptor
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["x-auth-token"] = token;
  }
  return config;
});

// Response interceptor
API.interceptors.response.use(
  (response) => response,
  (error) => {
    // Remove automatic logout on 401 errors
    // Only reject the promise, don't redirect
    return Promise.reject(error);
  }
);

export default API;
